import _get from 'lodash/get';

export default {
  computed: {
    role() {
      return _get(this.$store.state.profile, 'role');
    }
  }
};
